import Navbar from "../../components/navbar/Navbar";
import {
  AiOutlinePlusCircle,
  AiOutlineMinusCircle,
  AiOutlineDelete,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementQuantity, decrementQuantity, changeColor, changeSize,
  removeProduct, openPayment
} from "../../redux/cartSlice";
import PaymentForm from "../stripe/PaymentForm";

export default function Cart() {
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const handleDelete = (ID, price, quantity) => {
    dispatch(removeProduct({ ID, price, quantity }));
  };
  return (
    <div className="cart">
      <Navbar />
      <div className="cart flex flex-col md:flex-row px-2 lg:px-20 py-6 gap-4 mt-16">
        <div className="right flex flex-col flex-1 gap-2">
          {cart.products.map((product, index) => (
            <div
              key={product.ID + index}
              className="flex w-full h-134 md:h-36 rounded-md drop-shadow-md bg-white overflow-hidden"
            >
              <div className="img-container h-full overflow-hidden w-28 md:w-32 md:mr-4 lg:w-44 relative">
                  <p className="brand text-sm md:text-base text-gray-200 font-Roboto font-medium absolute top-0.5 left-1">
                      {product.brand}
                  </p>
                <img
                  className="h-full w-full object-cover"
                  src={product.image}
                  alt="product"
                />
              </div>

              <div className="flex w-full justify-between">
                <div className="info py-2 md:py-4 pl-2 flex flex-col justify-between">
                    <h2 className="title mb-1 text-base md:text-lg text-gray-700 font-Roboto font-medium md:font-semibold">
                      {product.title}
                    </h2>

                    <div className="colorAndSize flex flex-col md:flex-row gap-1 lg:gap-4 mb-1 justify-start">
                    <div className="color items-center flex justify-start gap-1 md:gap-2">
                      <h2 className="text-sm text-gray-600 font-Roboto font-medium">
                        Color:
                      </h2>
                      <select
                        name="color"
                        onChange={(e) => dispatch( changeColor({ID: product.ID, color: e.target.value}) ) }
                        className="p-1 md:p-2 text-gray-500 text-sm font-Roboto text-start bg-white border border-gray-500 rounded"
                      >
                        {product.color?.map((color, index) => (
                          <option key={color + index * index} value={color}>
                            {color}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="size items-center flex justify-start gap-1 md:gap-2">
                      <h2 className="text-sm text-gray-600 font-Roboto font-medium">
                        Size:
                      </h2>
                      <select
                        onChange={(e) => dispatch( changeSize({ID: product.ID, size: e.target.value}) )}
                        name="size"
                        className="p-1 md:p-2 text-gray-500 text-sm font-Roboto text-start bg-white border border-gray-500 rounded"
                      >
                        {product.size.map((size, index) => (
                          <option key={size + index * index} value={size}>
                            {size}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="quantity h-full flex md:hidden items-center justify-start gap-1">
                    <h3 className="text-sm text-gray-600 font-medium">
                      Quantity:
                    </h3>
                    <div className="flex items-center justify-between">

                        <AiOutlineMinusCircle size="1.5em"
                          className="drop-shadow cursor-pointer fill-gray-600 hover:fill-gray-500 transition"
                          onClick={() => dispatch( decrementQuantity({ID: product.ID}) ) }
                        />
                      <h1 className="px-2 text-base text-gray-600 drop-shadow font-Roboto font-medium">
                        {product?.quantity}
                      </h1>
                        <AiOutlinePlusCircle size="1.5em"
                          className="drop-shadow cursor-pointer fill-gray-600 hover:fill-gray-500 transition"
                          onClick={()=> dispatch( incrementQuantity({ID: product.ID}) ) }
                        />
                    </div>
                  </div>    
                  
                </div>

                <div className="hidden quantity h-full mx-1 md:flex flex-col items-center justify-center">
                  <div className="flex flex-col items-center justify-between">
                  <AiOutlineMinusCircle size="1.5em"
                          className="drop-shadow cursor-pointer fill-gray-600 hover:fill-gray-500 transition"
                          onClick={() => dispatch( decrementQuantity({ID: product.ID}) ) }
                        />
                      <h1 className="px-2 text-lg text-gray-600 drop-shadow font-Roboto font-medium">
                        {product?.quantity}
                      </h1>
                        <AiOutlinePlusCircle size="1.5em"
                          className="drop-shadow cursor-pointer fill-gray-600 hover:fill-gray-500 transition"
                          onClick={()=> dispatch( incrementQuantity({ID: product.ID}) ) }
                        />
                  </div>
                  <h3 className="text-sm text-gray-600 font-medium">
                    Quantity
                  </h3>
                </div>

                <div className="flex flex-col justify-between py-2 md:py-4 pr-2">
                  <div className="price flex flex-col items-center">
                    <h2 className="text-sm text-gray-700 font-Roboto font-medium mb-1">
                      price
                    </h2>
                    <p className="text-base text-gray-500 font-Roboto font-medium mb-1">
                      $ {(product.price * product.quantity).toFixed(2)}
                    </p>
                  </div>
                  <div className="remove flex justify-end">
                    <AiOutlineDelete
                      onClick={() =>
                        handleDelete(
                          product.ID,
                          product.price,
                          product.quantity
                        )
                      }
                      color="#EB5353"
                      size="1.6em"
                      className="drop-shadow cursor-pointer hover:fill-secondary-50 transition"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="left flex flex-col w-full h-full md:w-80 rounded-md drop-shadow-md bg-dark overflow-hidden p-4">
          <h1 className="title text-base lg:text-lg text-gray-50 font-Roboto font-medium lg:font-semibold text-center drop-shadow mb-2 md:mb-4">
            Continue to payment
          </h1>
          <div className="my-8">
            <div className="flex justify-between">
              <p className="title text-sm text-gray-400 font-Roboto font-semibold text-center drop-shadow">
                Sub total
              </p>
              <p className="title text-sm text-gray-400 font-Roboto font-semibold text-center drop-shadow">
                $ {cart.total.toFixed(2)}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="title text-sm text-gray-400 font-Roboto font-semibold text-center drop-shadow">
                Shipping
              </p>
              <p className="title text-sm text-gray-400 font-Roboto font-semibold text-center drop-shadow">
                {" "}
                $0
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-8">
            <div className="flex justify-between">
              <p className="title text-base text-gray-100 font-Roboto font-semibold text-center drop-shadow">
                Total price
              </p>
              <p className="title text-base text-gray-100 font-Roboto font-semibold text-center drop-shadow">
                $ {cart.total?.toFixed(2)}
              </p>
            </div>
            <button
              onClick={() => dispatch(openPayment())}
              className="p-1 w-full bg-primary text-white text-lg font-Roboto font-semibold rounded-md hover:bg-primary-200 transition-all"
            >
              CHECKOUT NOW
            </button>
          </div>
        </div>

      </div>
      {cart.openPayment && <PaymentForm />}
    </div>
  );
}
